import { collection, onSnapshot } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { db } from '../firebase/config';
import { ideasBatch } from '../Admin/data';

const InfoLists = () => {

     const [problems, setProblems] = useState([]);

     useEffect(() => {
          const unsub = onSnapshot(collection(db, "problems"), (snapshot) => {
               const data = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
               }));

               setProblems(data);
          });

          return () => unsub();
     }, []);


     const ideasCount = problems.filter(item => item.type === 'Idea').length;
     const problemsCount = problems.filter(item => item.type === 'Problem').length;


     const problemsCountAdmin = ideasBatch.filter(item => item.type === 'Problem').length;
     const ideasCountAdmin = ideasBatch.filter(item => item.type === 'Idea').length;


     const heroStats = [
          { value: ideasCount + ideasCountAdmin, label: 'Ideas saved' },
          { value: problemsCount + problemsCountAdmin, label: 'Problems saved' },
          { value: 'Soon', label: 'Collaborators joined' },
     ];

     return (
          <>
               <div className="forge-stats">
                    {heroStats.map(stat => (
                         <div key={stat.label} className="forge-stat-item">
                              <div className="stat-val">{stat.value || 0}</div>
                              <div className="stat-lab">{stat.label}</div>
                         </div>
                    ))}
               </div>

          </>
     );
}

export default InfoLists;
